import layout from '../../../../../SharedComponents/Styles/layout.module.scss';

import * as React from 'react';
import {connect} from 'react-redux';
import {reduxForm, FormSection} from 'redux-form';
import IStore from '../../../../../SharedRedux/Models/IStore';
import TextRadio from '../../../../../SharedComponents/Forms/TextRadio';
import StepNavigation from '../../Shared/StepNavigation';
import FormHeader from '../../Shared/FormHeader';
import {fullProfileSelector} from '../../../../Redux/Selectors/sharedSelectors';

interface IProps {
  handleSubmit: (arg: any) => void;
  isComplete?: boolean;
  pristine: any;
  submitting: any;
  nextBtnText: string;
  onNextClick: (arg: any) => void;
  onPreviousClick: () => void;
  previousBtnText: string;
}
interface IStateToProps {
  initialValues: any;
  labels: any;
  questions: any;
  units: any;
}

const mapStateToProps = (state: IStore, ownProps: IProps): IStateToProps => ({
  initialValues: fullProfileSelector(state),
  labels: (state.nFlight.localizedJson!.misc as any).labels,
  questions: (state.nFlight.localizedJson!.wedges as any).questions,
  units: state.nFlight.localizedJson!.units,
});

let MostLoftedWedge: any = (props: IProps & IStateToProps) => {
  const {
    handleSubmit,
    isComplete,
    labels,
    onNextClick,
    onPreviousClick,
    questions,
    nextBtnText,
    previousBtnText,
    units,
  } = props;

  const {mostLoftedWedge, numberOfWedges} = questions;

  return (
    <form onSubmit={handleSubmit(onNextClick) as any}>
      <FormSection name="wedgeProfile">
        <fieldset>
          <FormHeader isComplete={isComplete} header={labels.forms.loft} />
          <div className={layout.vr_4} />
          <TextRadio
            label={mostLoftedWedge.label}
            name="mostLoftedWedge"
            defaultValue={mostLoftedWedge.defaultValue}
            defaultValueLabel={labels.dontKnow}
            defaultValueTooltipText={mostLoftedWedge.helpText}
            options={mostLoftedWedge.options}
          />
          <TextRadio
            label={numberOfWedges.label}
            name="numberOfWedges"
            defaultValue={numberOfWedges.defaultValue}
            defaultValueLabel={labels.dontKnow}
            defaultValueTooltipText={numberOfWedges.helpText}
            options={numberOfWedges.options}
          />
          <StepNavigation
            nextBtnText={nextBtnText}
            onNextClick={onNextClick}
            onPreviousClick={onPreviousClick}
            previousBtnText={previousBtnText}
            formHandlesNext={true}
          />
        </fieldset>
      </FormSection>
    </form>
  );
};

MostLoftedWedge = reduxForm({
  form: 'profile',
  destroyOnUnmount: false, // The default value is true, but this application primarily uses false.
})(MostLoftedWedge);

MostLoftedWedge = connect(mapStateToProps)(MostLoftedWedge);

export default MostLoftedWedge;
